import React from 'react';
import { useApiKey } from '../contexts/ApiKeyContext';
import { Key, AlertCircle, CheckCircle, Loader2 } from 'lucide-react';

const ApiKeyStatus = () => {
  const { apiKey, isLoading, error } = useApiKey();

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-gray-800 rounded-xl border border-gray-600">
        <Loader2 className="h-4 w-4 text-purple-400 animate-spin" />
        <span className="text-sm text-gray-300">Loading API key...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-red-900/20 border border-red-700/50 rounded-xl">
        <AlertCircle className="h-4 w-4 text-red-400" />
        <span className="text-sm text-red-300">{error}</span>
      </div>
    );
  }

  if (apiKey) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-green-900/20 border border-green-700/50 rounded-xl">
        <CheckCircle className="h-4 w-4 text-green-400" />
        <span className="text-sm text-green-300">Verified</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2 px-3 py-2 bg-gray-800 rounded-xl border border-gray-600">
      <Key className="h-4 w-4 text-gray-400" />
      <span className="text-sm text-gray-300">No API Key</span>
    </div>
  );
};

export default ApiKeyStatus; 